// Duke Client Config
import template from "./_template";
import { isDev } from "../env";

const duke_config = {
  name: "duke",
  disabled_features: {
    ...template.disabled_features,
    // email: false, // Released to Prod 2021/04/08
  },
  enabled_features: {
    ...template.enabled_features,
    // Optional features
    dataset_dip: true,
    dataset_import: true,
    inbound_message: true, // Released to Prod 2021/04/08
    campaign_templates: true, // DE-709 Storm Templates
    push_notification_channel: true, // DE-769 Push Notification
    emergency_campaign_priority: true, // DE-705
    wav_upload: true, //DE-1767
    url_shortner: true, //DE-1765
    do_not_select_folder_disable: true, //DE-2088
    sort_dataset_labels: true,
    campaign_tag: true,
  },
  custom_labels: {
    district_vch: "Jurisdiction",
    custom4_vch: "Custom Header 4",
    custom5_vch: "Custom Header 5",
    account_vch: "Contract Account",
    parent_account_vch: "Business Partner",
    priority_flag_vch: "Event IDX",
    circuit_vch: "Substation",
    voltage_vch: "Op Center",
  },
  sms: {
    short_codes: [
      { value: "56377", label: "56377 Piedmont Natural Gas" }, // REST
      { value: "30296", label: "30296 Emergency/Storm" }, // XML https://mbroadcast.atlassian.net/browse/DE-114
      { value: "21209", label: "21209 Planned Outage" }, // REST https://mbroadcast.atlassian.net/browse/DE-506
      { value: "82291", label: "82291 Non Emergency" }, // REST https://mbroadcast.atlassian.net/browse/DE-670
      { value: "71729", label: "71729 Non-Native" }, // REST https://mbroadcast.atlassian.net/browse/DE-1026
    ],
  },
  voice: {
    premium_options: ["spanish"], //DE-1766
    caller_id_options: [
      { label: "Select a phone number", isDisabled: true },
      { value: "3529143853", label: "(352) 914-3853 - Florida (DEF North Gulf)" },
      { value: "3526563853", label: "(352) 656-3853 - Florida (DEF North Gulf)" },
      { value: "8507063853", label: "(850) 706-3853 - Florida (DEF North Panhandle)" },
      { value: "4075593853", label: "(407) 559-3853 - Florida (DEF Orlando)" },
      { value: "6893563853", label: "(689) 356-3853 - Florida (DEF Orlando)" },
      { value: "4079043853", label: "(407) 904-3853 - Florida (DEF Orlando)" },
      { value: "6893483853", label: "(689) 348-3853 - Florida (DEF Orlando)" },
      { value: "7727103853", label: "(772) 710-3853 - Florida (DEF Space Coast)" },
      { value: "7277390003", label: "(727) 739-0003 - Florida (DEF St. Petersburg)" },
      { value: "2193553853", label: "(219) 355-3853 - Indiana (DEI Gary)" },
      { value: "4632131110", label: "(463) 213-1110 - Indiana (DEI Indianapolis)" },
      { value: "2702693853", label: "(270) 269-3853 - Kentucky (DEK Western)" },
      { value: "5139983853", label: "(513) 998-3853 - Ohio (DEO Cincinnati)" },
      { value: "2342523853", label: "(234) 252-3853 - Ohio (DEO Northeast)" },
      { value: "7048793450", label: "(704) 879-3450 - North Carolina (DEC Charlotte)" },
      { value: "7047418020", label: "(704) 741-8020 - North Carolina (DEC Charlotte)" },
      { value: "9807583853", label: "(980) 758-3853 - North Carolina (DEC Charlotte)" },
      { value: "9802655600", label: "(980) 265-5600 - North Carolina (DEC Charlotte)" },
      { value: "9803803853", label: "(980) 380-3853 - North Carolina (DEC Charlotte)" },
      { value: "9803913853", label: "(980) 391-3853 - North Carolina (DEC Charlotte)" },
      { value: "8285794701", label: "(828) 579-4701 - North Carolina (DEP Asheville)" },
      { value: "8287953853", label: "(828) 795-3853 - North Carolina (DEP Asheville)" },
      { value: "2528993853", label: "(252) 899-3853 - North Carolina (DEP Northeast)" },
      { value: "9194218088", label: "(919) 421-8088 - North Carolina (DEP Triangle)" },
      { value: "9198975300", label: "(919) 897-5300 - North Carolina (DEP Triangle)" },
      { value: "9844893853", label: "(984) 489-3853 - North Carolina (DEP Triangle)" },
      { value: "9107563853", label: "(910) 756-3853 - North Carolina (DEP Wilmington)" },
      { value: "8439313853", label: "(843) 931-3853 - South Carolina (DEP Coastal)" },
      { value: "8439663853", label: "(843) 966-3853 - South Carolina (DEP Coastal)" },
      { value: "8542043853", label: "(854) 204-3853 - South Carolina (DEP Coastal)" },
      { value: "8032743853", label: "(803) 274-3853 - South Carolina (DEC Rock Hill)" },
      { value: "8393881110", label: "(839) 388-1110 - South Carolina (DEC Rock Hill)" },
      { value: "8649993853", label: "(864) 999-3853 - South Carolina (DEC Western)" },
      { value: "4236583853", label: "(423) 658-3853 - Tennessee (PNG Eastern)" },
      { value: "8556733853", label: "(855) 673-3853 - Toll Free" },
      { value: "8662903853", label: "(866) 290-3853 - Toll Free" },
      { value: "8666493853", label: "(866) 649-3853 - Toll Free" },
      { value: "8774303853", label: "(877) 430-3853 - Toll Free" },
      { value: "8776283853", label: "(877) 628-3853 - Toll Free" },
      { value: "8779643853", label: "(877) 964-3853 - Toll Free" },
      { value: "8885633853", label: "(888) 563-3853 - Toll Free" },
      { value: "8887503853", label: "(888) 750-3853 - Toll Free" },
      { value: "8888593853", label: "(888) 859-3853 - Toll Free" },
      { value: "8889013853", label: "(888) 901-3853 - Toll Free" },
    ],
  },
};

if (isDev()) {
  duke_config.voice.caller_id_options.push({
    value: "2253177676",
    label: "(225) 317-7676 - DEMO QA TEST",
  });
}
export default duke_config;
